import { t } from './localization.js';

const mainElemCSSPath = '.top-panel_selected';
const hiddenClassName = 'top-panel_hidden';
const clearBtnCSSPath = `${mainElemCSSPath} .top-panel__btn-clear`;
const textCSSPath = `${mainElemCSSPath} .top-panel__selected-text`;

const getElem = () => document.querySelector(mainElemCSSPath);

const getTextForSelect = (amount) => t('home-selected-count-label', { count: amount });

export function initSelectedPanel() {
  return {
    show,
    hide,
    onClickClearBtn,
    updateAmountOfSelect,
  };

  function show() {
    const $elem = getElem();
    $elem.classList.remove(hiddenClassName);
  }

  function hide() {
    const $elem = getElem();
    $elem.classList.add(hiddenClassName);
  }

  function onClickClearBtn(cb) {
    const $elem = document.querySelector(clearBtnCSSPath);
    $elem.addEventListener('click', cb);
  }

  function updateAmountOfSelect(amount) {
    const $elem = document.querySelector(textCSSPath);
    $elem.innerHTML = getTextForSelect(amount);
  }
}
